import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { AuthLoadingSpinner } from "./AuthLoadingSpinner";
import { SignInRequiredDialog } from "./SignInRequiredDialog";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();


  if (loading) {
    return <AuthLoadingSpinner />;
  }

  if (!user) {
    // Guest: explain why instead of silently bouncing to the landing page.
    // Closing always returns to the Home dashboard — never the Explore map.
    return (
      <SignInRequiredDialog
        open
        onOpenChange={(open) => {
          if (!open) navigate("/dashboard", { replace: true });
        }}
        feature="open this page"
      />
    );
  }

  return <>{children}</>;
}
